const hasLineItemType = (lineItems, productType) => lineItems.some((item) => productType === item.type);
export {
  hasLineItemType
};
//# sourceMappingURL=has-line-item-type.js.map
